import React from 'react'
import { Text, StyleSheet } from 'react-native'
import {
  ProjectSections,
  PROJECT_SECTIONS,
} from '@linqpal/models/src/dictionaries'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../store'

interface ConditionalTitleProps {
  section?: ProjectSections
  route: any
}
export const ConditionalTitle: React.FC<ConditionalTitleProps> = ({
  section,
  route,
}) => {
  const { t } = useTranslation('global')
  const store = useStore()
  const added = store?.userStore.projectAdded
  if (section !== PROJECT_SECTIONS.ADDRESS) return null
  else if (route.params?.ids && !added) {
    return (
      <>
        <Text style={styles.headingDesktop}>
          {t('ProjectForm.main-heading-when-no-projects-exist')}
        </Text>
        <Text style={styles.subheadingDesktop}>
          {t('ProjectForm.main-subheading')}
        </Text>
      </>
    )
  } else if (route.params?.withInvoice) {
    return (
      <>
        <Text style={styles.headingDesktop}>
          {t('ProjectForm.main-heading-when-projects-exist')}
        </Text>
        <Text style={styles.subheadingDesktop}>
          {t('ProjectForm.main-subheading')}
        </Text>
      </>
    )
  } else return null
}

const styles = StyleSheet.create({
  headingDesktop: {
    marginTop: 30,
    fontWeight: '700',
    fontSize: 32,
    lineHeight: 48,
    color: '#394D5A',
  },
  subheadingDesktop: {
    marginTop: 7,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: '#394D5A',
    letterSpacing: -0.5,
  },
})
